import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { AppModalHeader } from '../../common/AppModalHeader';
import { useEngageUsersStore } from '../Provider/useEngageUsersStore';
import UpdateRoleForm from '../Forms/UpdateRoleForm';

export default function UpdateRoleModal() {
    const user = useEngageUsersStore(state => state.selected);
    const isOpen = useEngageUsersStore(state => state.modalOpen);
    const close = useEngageUsersStore(state => state.closeModal);

    return (
        <>
            <Modal className="modal-md" isOpen={isOpen} toggle={close}>
                <AppModalHeader toggle={close}>Update Role for {user?.name}</AppModalHeader>
                <ModalBody>
                    <UpdateRoleForm />
                </ModalBody>
            </Modal>
        </>
    );
}
